// src/components/ViewSummaryChips.jsx
import SoftBox from "components/SoftBox";
import Chip from "@mui/material/Chip";

/* ---------- label helpers ---------- */

function labelForTab(tab) {
  return tab === "flow" ? "Flow" : "Occupancy";
}

function labelForMetric(metric) {
  if (metric === "ingress") return "Ingress";
  if (metric === "egress") return "Egress";
  if (metric === "net") return "Net";
  return metric;
}

function labelForGrouping(grouping) {
  if (grouping === "group") return "Area";
  if (grouping === "subgroup") return "Sub-area";
  if (grouping === "camera") return "Camera";
  return "None";
}

function labelForViewMode(viewMode) {
  return viewMode === "compare" ? "Compare" : "Single";
}

function labelForFlowMode(flowMode) {
  return flowMode === "cumulative" ? "Cumulative" : "Per interval";
}

/* ---------- component ---------- */

export default function ViewSummaryChips({ view }) {
  const chips = [];

  // Always show which tab we're in
  chips.push({
    key: "tab",
    label: labelForTab(view.tab)
  });

  // Flow-only context
  if (view.tab === "flow") {
    chips.push({ key: "metric", label: labelForMetric(view.metric) });
    chips.push({
      key: "grouping",
      label: `Group: ${labelForGrouping(view.grouping)}`
    });
    chips.push({
      key: "viewMode",
      label: labelForViewMode(view.viewMode)
    });
    chips.push({
      key: "flowMode",
      label: labelForFlowMode(view.flowMode)
    });

    if (view.viewMode === "compare") {
      chips.push({
        key: "stack",
        label: view.stacked ? "Stacked" : "Overlap"
      });
      chips.push({
        key: "total",
        label: view.showTotal ? "Total: On" : "Total: Off"
      });
    }
  }

  return (
    <SoftBox display="flex" gap={1} flexWrap="wrap" alignItems="center">
      {chips.map((c) => (
        <Chip
          key={c.key}
          label={c.label}
          size="small"
          variant="outlined"
        />
      ))}
    </SoftBox>
  );
}
``
